import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/Select.docs.json';
import { Select, Text } from '@primer/react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Preferred Primer component interface</FormControl.Label>
  <Select>
    <Select.Option value="figma">Figma</Select.Option>
    <Select.Option value="css">Primer CSS</Select.Option>
    <Select.Option value="prc">Primer React components</Select.Option>
    <Select.Option value="pvc">Primer ViewComponents</Select.Option>
  </Select>
</FormControl>
`}</code></pre>
    <h3>{`With grouped options`}</h3>
    <Note mdxType="Note">
      <p><inlineCode parentName="p">{`OptGroup`}</inlineCode>{` labels are not accessible to all screen readers, so they cannot convey critical information just information that improves usability.`}</p>
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Preferred Primer component interface</FormControl.Label>
  <Select>
    <Select.OptGroup label="GUI">
      <Select.Option value="figma">Figma</Select.Option>
    </Select.OptGroup>
    <Select.OptGroup label="Code">
      <Select.Option value="css">Primer CSS</Select.Option>
      <Select.Option value="prc">Primer React components</Select.Option>
      <Select.Option value="pvc">Primer ViewComponents</Select.Option>
    </Select.OptGroup>
  </Select>
</FormControl>
`}</code></pre>
    <h3>{`With a placeholder`}</h3>
    <Note mdxType="Note">
  Select placeholders cannot be used in place of labels and should be used sparingly. They also should not convey
  critical information.
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Preferred Primer component interface</FormControl.Label>
  <Select placeholder="Pick an interface">
    <Select.Option value="figma">Figma</Select.Option>
    <Select.Option value="css">Primer CSS</Select.Option>
    <Select.Option value="prc">Primer React components</Select.Option>
    <Select.Option value="pvc">Primer ViewComponents</Select.Option>
  </Select>
</FormControl>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: false,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      